export const transFormDataType = (data) => {
  if (data && Array.isArray(data)) {
    const arr = []
    if (data.length) {
      data.forEach((it) => {
        if (it) {
          arr.push(it + '')
        }
      })
    }
    return arr
  }
  if (data) {
    return data + ''
  }
  return data
}
